module.exports = __webpack_public_path__ + "img/noneImg.f71b21b0.png";